// UI copy shared by the portal and public surveys. Customer content is never translated.
export const portalNL = {
  question_option_label: 'Optie {{option}} van vraag {{question}}',
  surveys: 'Enquêtes',
  survey: 'Enquête',
  listen_to_your_customers_and_assign_tags_after_submission:
    'Luister naar je klanten en wijs tags toe na het invullen.',
  select_a_venue_to_manage_surveys:
    'Selecteer een locatie om enquêtes te beheren.',
  create_survey: 'Enquête maken',
  edit_survey: 'Enquête bewerken',
  search_surveys_by_name: 'Enquêtes op naam zoeken',
  search_for_a_survey_by_name: 'Zoek een enquête op naam…',
  no_surveys_found: 'Geen enquêtes gevonden',
  create_your_first_survey_to_collect_feedback_and_ratings:
    'Maak je eerste enquête om feedback en beoordelingen te verzamelen.',
  published: 'Gepubliceerd',
  paused_draft: 'Gepauzeerd / concept',
  responses: 'Antwoorden',
  rating: 'Beoordeling',
  none_yet: 'Nog geen',
  customer_link: 'Klantlink',
  surveys_2: 'enquêtes',
  questions: 'vragen ·',
  tags: 'tags',
  responses_2: 'antwoorden',
  survey_saved: 'Enquête opgeslagen',
  save_survey: 'Enquête opslaan',
  write_your_questions_a_five_star_rating_is_always_included_at_the_end:
    'Schrijf je vragen. Aan het einde staat altijd een beoordeling met vijf sterren.',
  survey_name: 'Naam van de enquête *',
  e_g_how_was_your_dinner: 'Bijv. Hoe was je diner?',
  introduction_for_the_customer: 'Inleiding voor de klant',
  tags_to_add_after_submission: 'Tags om na het versturen toe te voegen',
  these_are_added_to_the_customer_s_tags_without_removing_existing_ones:
    'Deze worden toegevoegd zonder bestaande klanttags te verwijderen.',
  loading_tags: 'Tags laden…',
  select_venue_tags: 'Selecteer locatietags',
  question_and_answer_tags_are_not_yet_supported_by_the_connected_service_you_can_confi:
    'De gekoppelde dienst ondersteunt nog geen vraag- en antwoordtags. Je kunt ze hier instellen, maar opslaan kan pas na een update van de dienst.',
  question_and_answer_tags_require_an_update_to_the_connected_service_the_survey_was_no:
    'Vraag- en antwoordtags vereisen een update van de gekoppelde dienst. De enquête is niet opgeslagen.',
  enter_a_name_question_text_and_at_least_two_distinct_options_for_choice_questions:
    'Vul een naam, vraagteksten en minstens twee verschillende opties voor keuzevragen in.',
  question: 'Vraag',
  question_text: 'Vraagtekst *',
  answer_type: 'Antwoordtype',
  text_answer: 'Open antwoord',
  single_choice_one_answer: 'Enkele keuze — één antwoord',
  multiple_choice_several_answers: 'Meerkeuze — meerdere antwoorden',
  question_tags: 'Vraagtags',
  added_when_the_customer_answers_this_question:
    'Toegevoegd wanneer de klant deze vraag beantwoordt.',
  no_tags_for_this_question: 'Geen tags voor deze vraag',
  answer_options_2_to_20: 'Antwoordopties (2 tot 20)',
  tags_when_the_customer_selects_this_answer:
    'Tags wanneer de klant dit antwoord kiest',
  select_tags_for_this_answer: 'Selecteer tags voor dit antwoord',
  add_option: 'Optie toevoegen',
  remove_option: 'Optie verwijderen',
  required_answer: 'Verplicht antwoord',
  add_question: 'Vraag toevoegen',
  move_question_up: 'Vraag omhoog verplaatsen',
  move_question_down: 'Vraag omlaag verplaatsen',
  remove_question: 'Vraag verwijderen',
  final_rating_from_1_to_5_stars: 'Eindbeoordeling van 1 tot 5 sterren',
  the_customer_selects_a_star_rating_before_submitting_the_survey:
    'De klant kiest een sterrenbeoordeling voordat de enquête wordt verstuurd.',
  publish_survey: 'Enquête publiceren',
  when_disabled_links_no_longer_accept_responses_existing_responses_remain_saved:
    'Als dit is uitgeschakeld, accepteren de links geen antwoorden. Bestaande antwoorden blijven bewaard.',
  survey_preview: 'Enquêtevoorbeeld',
  create_a_customer_link: 'Een klantlink maken',
  search_customers_by_name_email_or_code:
    'Zoek klanten op naam, e-mail of code',
  type_at_least_2_characters: 'Typ minstens 2 tekens…',
  searching: 'Zoeken…',
  no_customers_found: 'Geen klanten gevonden.',
  generate_customer_link: 'Klantlink genereren',
  this_link_associates_the_response_with_the_selected_customer:
    'Deze link koppelt het antwoord aan de geselecteerde klant.',
  survey_link: 'Enquêtelink',
  link_copied: 'Link gekopieerd',
  copy_the_link_manually_from_the_field_above:
    'Kopieer de link handmatig uit het veld hierboven.',
  loading_responses: 'Antwoorden laden…',
  you_have_not_received_any_responses_yet:
    'Je hebt nog geen antwoorden ontvangen.',
  tags_added: 'Toegevoegde tags:',
  the_request_could_not_be_completed: 'Het verzoek kon niet worden voltooid.',
  your_opinion_matters: 'Jouw mening telt',
  the_link_is_incomplete_ask_the_venue_for_a_new_link:
    'De link is onvolledig. Vraag de locatie om een nieuwe link.',
  this_survey_is_unavailable_ask_the_venue_for_a_new_link:
    'Deze enquête is niet beschikbaar. Vraag de locatie om een nieuwe link.',
  we_could_not_load_the_survey_please_try_again:
    'De enquête kon niet worden geladen. Probeer het opnieuw.',
  loading_failed: 'Laden mislukt.',
  the_survey_has_been_updated_please_review_the_questions:
    'De enquête is bijgewerkt. Controleer de vragen opnieuw.',
  check_your_answers_and_choose_a_rating_from_1_to_5_stars:
    'Controleer je antwoorden en kies 1 tot 5 sterren.',
  submission_failed_please_try_again_shortly:
    'Versturen mislukt. Probeer het zo opnieuw.',
  submission_failed: 'Versturen mislukt.',
  your_voice_helps_us_grow: 'Jouw stem helpt ons groeien',
  a_moment_to_listen: 'EVEN NAAR JOU LUISTEREN',
  your_feedback_makes_a_difference: 'Jouw feedback maakt het verschil.',
  preparing_your_survey: 'Je enquête wordt voorbereid…',
  responses_sent: 'ANTWOORDEN VERSTUURD',
  thank_you_for_your_feedback: 'Bedankt voor je feedback!',
  your_answers_have_been_recorded_thank_you_for_taking_the_time_to_help_us_improve:
    'Je antwoorden zijn opgeslagen. Bedankt dat je de tijd hebt genomen om ons te helpen verbeteren.',
  tell_us_about_your_experience: 'Vertel ons over je ervaring',
  answer_the_questions_and_leave_your_final_rating:
    'Beantwoord de vragen en geef je eindbeoordeling.',
  your_answers_are_linked_to_your_customer_profile:
    'Je antwoorden worden gekoppeld aan je klantprofiel.',
  powered_by: 'Mogelijk gemaakt door',
  optional: ' (optioneel)',
  write_your_answer_here: 'Schrijf hier je antwoord…',
  choose_one_answer: 'Kies één antwoord.',
  you_can_choose_several_answers: 'Je kunt meerdere antwoorden kiezen.',
  how_would_you_rate_your_experience: 'Hoe beoordeel je je ervaring? *',
  choose_from_1_to_5_stars: 'Kies 1 tot 5 sterren.',
  no_rating_selected: 'Geen beoordeling geselecteerd',
  submit_your_feedback: 'Feedback versturen',
  text_answers_can_contain_up_to_5_000_characters:
    'Open antwoorden mogen maximaal 5.000 tekens bevatten.',
  choose_a_valid_answer: 'Kies een geldig antwoord.',
  choose_only_the_available_options: 'Kies alleen de beschikbare opties.',
  choose_a_rating_from_1_to_5_stars:
    'Kies een beoordeling van 1 tot 5 sterren.',
  complete_the_question_value: 'Beantwoord de vraag: {{question}}',
  value_out_of_5_stars: '{{count}} van 5 sterren',
  value_stars: '{{count}} sterren',
  value_questions_value_tags: '{{count}} vragen · {{tags}} tags',
  value_responses: '{{count}} antwoorden',
  value_surveys: '{{count}} enquêtes',
  value_questions_rating: '{{count}} vragen + beoordeling',
  responses_value: 'Antwoorden · {{name}}',
};
